module.exports = __webpack_public_path__ + "img/bg_votebtn_gold.ab554c21.png";